import _ from 'lodash'
import axios from 'axios'

const brTag = '<br />'
const nextLine = '\n'

class BaseUtil {
  STtoObj (json) {
    if (json === null || json === '' || json === undefined) {
      return {}
    } else if (typeof json === 'object') {
      return json
    } else {
      json = json
        .replace(/\n/g, '')
        .replace(/\r/g, '')
        .replace(/\t/g, '')
        .replace(/\f/g, '')
        .replace(/&amp;/g, '&')
        .replace(/&amp/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&lt/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&gt/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&quot/g, '"')

      return JSON.parse(json)
    }
  }
}

export default class CommonUtil {
  constructor () {
    this.baseUtil = new BaseUtil()
  }

  /**
   * debounce Method
   */
  debounce (func, wait = 100) {
    let timeout
    return function (...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(this, args)
      }, wait)
    }
  }

  // null,undefined,빈문자열 입력시 true 리턴
  isNullValue (val) {
    if (Array.isArray(val)) {
      return false
    } else {
      return val === undefined || val === null || (val + '').trim() === ''
    }
  }

  isEmptyObject (obj) {
    return !Object.keys(obj).length
  }

  isKorean (text) {
    const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi
    return reg.test(text)
  }

  isNumberValue (val) {
    return !this.isNullValue(val) && !isNaN((val + '').replace(/,/gi, ''))
  }

  isBoolCheck (val) {
    if (typeof val === 'boolean') return val
    else return null
  }

  // urlEncoding문자열 생성
  toUrlEncoding (str) {
    return encodeURIComponent(str)
  }

  // urlEncoding문자열을  decoding
  toUrlDecoding (encStr) {
    return decodeURIComponent(encStr)
  }

  // get 파라미터로 넘어온 주소 문자열 반환
  getUrlParam () {
    return location.search
      .replace('?', '')
      .split('&')
      .reduce(function (s, c) {
        let t = c.split('=')
        s[t[0]] = t[1]
        return s
      }, {})
  }

  setLocalStorage (key, value) {
    localStorage.setItem(key, value)
  }

  getLocalStorage (key) {
    return localStorage.getItem(key)
  }

  removeLocalStorage (key) {
    localStorage.removeItem(key)
  }

  setFormData (arr) {
    if (Array.isArray(arr)) {
      let formData = new FormData()
      for (let param of arr) {
        if (Object.values(param)[0] !== null) {
          formData.append(Object.keys(param)[0], Object.values(param)[0])
        }
      }
      return formData
    } else {
      console.log('Array 타입만 가능합니다.')
      return null
    }
    // reader.readAsArrayBuffer(file)
  }

  // 122121.122222 → 122,121.1
  toFixed (val, digit, ignoreInt) {
    if (this.isNullValue(val)) {
      return ''
    } else {
      let result = null
      if (this.isNullValue(ignoreInt)) {
        ignoreInt = false
      }

      val = parseFloat((val + '').replace(/,/gi, ''))

      if (val === parseInt(val) && (!ignoreInt)) {
        result = new Intl.NumberFormat(['ko-KR'],
          {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(val)
      } else {
        digit = this.isNullValue(digit) ? 0 : digit
        result = new Intl.NumberFormat(['ko-KR'],
          {
            minimumFractionDigits: digit,
            maximumFractionDigits: digit
          }).format(parseFloat(val))
      }
      return result === 'NaN' ? 'N/A' : result
    }
  }

  replaceBrToLineBreak (message) {
    if (this.isNullValue(message)) {
      return ''
    }
    return message.replace(/<br \/>/gi, nextLine).replace(/<br\/>/gi, nextLine)
  }

  replaceLineBreakToBr (message) {
    if (this.isNullValue(message)) {
      return ''
    }
    return message.replace(/\/r\/n/gi, brTag).replace(/\/n/gi, brTag)
  }

  toJSON (obj) {
    if (this.isNullValue(obj)) {
      throw Error(
        'null 객체는 json 문자열로 변환 할 수 없습니다. (CommonUtil.toJson)'
      )
    }
    return JSON.stringify(obj)
  }

  toObj (json) {
    return this.baseUtil.STtoObj(json)
  }

  getPropertyNames (obj) {
    if (this.isNullValue(obj) || typeof obj !== 'object') {
      throw Error(
        'obj는 반드시 객체이여야 합니다. (CommonUtil.getPropertyNames)'
      )
    }
    return Object.keys(obj).map(key => key)
  }

  ResolveReferences (json) {
    json = json.replace(/\t/gi, '\\t').replace(/\n/gi, '\\n')

    if (typeof json === 'string') json = this.baseUtil.STtoObj(json)

    var byid = {} // all objects by id
    var refs = [] // references to objects that could not be resolved
    json = (function recurse (obj, prop, parent) {
      if (typeof obj !== 'object' || !obj)
      // a primitive value
      // eslint-disable-next-line brace-style
      { return obj }
      if (Object.prototype.toString.call(obj) === '[object Array]') {
        for (var i = 0; i < obj.length; i++) {
          if ('$ref' in obj[i]) obj[i] = recurse(obj[i], i, obj)
          else obj[i] = recurse(obj[i], prop, obj)
        }
        return obj
      }
      if ('$ref' in obj) {
        // a reference
        var ref = obj.$ref
        if (ref in byid) return byid[ref]
        // else we have to make it lazy:
        refs.push([parent, prop, ref])
        return
      } else if ('$id' in obj) {
        var id = obj.$id
        delete obj.$id
        if ('$values' in obj)
        // an array
        // eslint-disable-next-line brace-style
        { obj = obj.$values.map(recurse) }
        // a plain object
        else {
          for (var objProp in obj) { obj[objProp] = recurse(obj[objProp], objProp, obj) }
        }
        byid[id] = obj
      }
      return obj
    })(json) // run it!

    for (var i = 0; i < refs.length; i++) {
      // resolve previously unknown references
      var ref = refs[i]
      ref[0][ref[1]] = byid[ref[2]]
      // Notice that this throws if you put in a reference at top-level
    }
    return json
  }

  getGUID () {
    let guidFunc = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }

    return `${guidFunc()}${guidFunc()}-${guidFunc()}-${guidFunc()}-${guidFunc()}-${guidFunc()}${guidFunc()}${guidFunc()}`
  }

  wordEllipsis (stringVal, cLength, defaultVal) {
    if (this.isNullValue(stringVal)) {
      return this.isNullValue(defaultVal) ? '' : defaultVal
    } else {
      if (this.isNullValue(cLength)) {
        cLength = 10
      }

      return stringVal.substr(0, cLength) + '...'
    }
  }

  getHierarchyObject (id, parentId, content, targetArray) {
    let map = {}
    for (let i = 0, max = targetArray.length; i < max; i++) {
      targetArray[i].label = targetArray[i][content] // element tree
      targetArray[i].text = targetArray[i][content] // jstree
      let obj = targetArray[i]
      obj.children = []

      map[obj[id]] = obj
      let parent = obj[parentId] || '-'
      if (!map[parent]) {
        map[parent] = {
          children: []
        }
      }
      map[parent].children.push(obj)
    }

    return map['-'].children
  }

  replaceAll (str, searchStr, replaceStr) {
    return str.split(searchStr).join(replaceStr)
  }

  attachEnterEventListener (targets, obj, method) {
    let targetElements = null
    if (Array.isArray(targets)) {
      targetElements = _.toString(targets)
    } else if (typeof targets === 'string') {
      targetElements = targets
    }

    if (this.isNullValue(targetElements)) return

    targetElements.on('keypress', function (e) {
      // console.log(e.which);
      if (e.which === 13) {
        try {
          obj[method]()
          e.preventDefault()
        } catch (e) {
          console.log(e.message)
        }
      }
    })
  }

  openWindow (url, windowName, width, height) {
    if (this.isNullValue(url) || this.isNullValue(windowName)) {
      // eslint-disable-next-line no-throw-literal
      throw 'openWindow-url,windowName은 필수입력요소'
    }

    if (
      this.isNullValue(width) === true ||
      this.isNumberValue(width) === false
    ) {
      width = 800
    }

    if (
      this.isNullValue(height) === true ||
      this.isNumberValue(width) === false
    ) {
      height = 600
    }
    window.open(
      url,
      windowName,
      `width=${width}, height=${height}, toolbar=no, menubar=no, scrollbars=yes, resizable=yes`
    )
  }

  getYearSource (minYear, afterYear) {
    let years = []
    let eYear = new Date().getFullYear()
    let sYear = 2000
    if (minYear != null) {
      sYear = minYear
    }

    if (afterYear == null) {
      afterYear = 1
    }
    console.log(eYear + afterYear)
    for (let i = eYear + afterYear; i >= sYear; i--) {
      years.push({ index: i.toString(), label: `${i}년` })
    }
    return years
  }

  setInitVueObject (obj) {
    if (this.isNullValue(obj)) {
      return obj
    }

    if (typeof obj === 'object') {
      let props = Object.keys(obj)

      for (let prop of props) {
        if (typeof obj[prop] === 'object') {
          // array, datetime 모두 object타입으로 구분됨
          obj[prop] = this.setInitVueObject(obj[prop])
        } else if (typeof obj[prop] === 'string') {
          obj[prop] = obj[prop] === '' ? null : obj[prop]
        } else if (typeof obj[prop] === 'number') {
          console.log('number')
        }
      }
      return obj
    } else {
      return obj
    }
  }

  getFileExtension (targetFileName) {
    let fileName = targetFileName.split(/(\\|\/)/g).pop()
    let extType = fileName.split('.').pop()
    return extType
  }

  // 시간 변환 해오기
  replaceTime (time) {
    let check = /[~!@#$%^&*()_+|<>?:{}]/.test(time)
    // 라는 특수문자가 있는 경우
    if (check) {
      return time.split(':').join()
    } else {
      return time.slice(0, 2) + ':' + time.slice(2, 4)
    }
  }

  // 전화번호 (-)하이픈 추가
  replacePhoneNumber (phoneNumber) {
    if (phoneNumber) {
      return phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4,5})$/, `$1-$2-$3`)
    }
  }

  // 사업자등록번호
  replaceCompanyNumber (companyNumber) {
    if (companyNumber) {
      return companyNumber.replace(/^(\d{3})(\d{2})(\d{5})$/, `$1-$2-$3`)
    }
  }

  // 만 나이 변경
  calcAge (birth) {
    if (birth) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      let monthDay = month + day
      birth = birth.replace('-', '').replace('-', '')
      let birthday = birth.substr(0, 4)
      let birthdayMd = birth.substr(4, 4)
      let age = monthDay < birthdayMd ? year - birthday - 1 : year - birthday
      return age
    }
  }

  getAgent () {
    let ua = navigator.userAgent.toLowerCase()
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)

    let result = {
      device: isMobile ? 'MOBILE' : 'PC',
      os: this.getOS(ua),
      browser: this.getBrowser(ua)
    }
    return result
  }

  getOS (ua) {
    let os = ''
    if (ua.match(/Win(dows )?NT 6\.0/)) {
      os = 'Windows Vista'
    } else if (ua.match(/Win(dows )?(NT 5\.1|XP)/)) {
      os = 'Windows XP'
    } else {
      if ((ua.indexOf('Windows NT 5.1') !== -1) || (ua.indexOf('Windows XP') !== -1)) {
        os = 'Windows XP'
      } else if ((ua.indexOf('Windows NT 7.0') !== -1) || (ua.indexOf('Windows NT 6.1') !== -1)) {
        os = 'Windows 7'
      } else if ((ua.indexOf('Windows NT 8.0') !== -1) || (ua.indexOf('Windows NT 6.2') !== -1)) {
        os = 'Windows 8'
      } else if ((ua.indexOf('Windows NT 8.1') !== -1) || (ua.indexOf('Windows NT 6.3') !== -1)) {
        os = 'Windows 8.1'
      } else if ((ua.indexOf('Windows NT 10.0') !== -1) || (ua.indexOf('Windows NT 6.4') !== -1)) {
        os = 'Windows 10'
      } else if ((ua.indexOf('iPad') !== -1) || (ua.indexOf('iPhone') !== -1) || (ua.indexOf('iPod') !== -1)) {
        os = 'Apple iOS'
      } else if (ua.indexOf('Android' !== -1)) {
        os = 'Android OS'
      } else if (ua.match(/Win(dows )?NT( 4\.0)?/)) {
        os = 'Windows NT'
      } else if (ua.match(/Mac|PPC/)) {
        os = 'Mac OS'
      } else if (ua.match(/Linux/)) {
        os = 'Linux'
      } else if (ua.match(/(Free|Net|Open)BSD/)) {
        os = RegExp.$1 + 'BSD'
      } else if (ua.match(/SunOS/)) {
        os = 'Solaris'
      }
    }
    if (os.indexOf('Windows') !== -1) {
      if (navigator.userAgent.indexOf('WOW64') > -1 || navigator.userAgent.indexOf('Win64') > -1) {
        os += ' 64bit'
      } else {
        os += ' 32bit'
      }
    }

    return os
  }

  getBrowser (ua) {
    if (ua.indexOf('edge') > -1) return 'EDGE'
    else if (ua.indexOf('whale') > -1) return 'WHALE'
    else if (ua.indexOf('chrome') > -1) return 'CHROME'
    else if (ua.indexOf('firefox') > -1) return 'FIREFOX'
    else return 'EXPLORE'
  }

  getIP () {
    const ipSrc = 'https://api.ipify.org?format=json'
    return axios.get(ipSrc)
  }
}
